import { render, staticRenderFns } from "./panel.vue?vue&type=template&id=2e5d5009&"
import script from "./panel.vue?vue&type=script&lang=js&"
export * from "./panel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/builds/MWmsPKDH/0/framework/qmai-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e5d5009')) {
      api.createRecord('2e5d5009', component.options)
    } else {
      api.reload('2e5d5009', component.options)
    }
    module.hot.accept("./panel.vue?vue&type=template&id=2e5d5009&", function () {
      api.rerender('2e5d5009', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/qm-picture-library/src/panel.vue"
export default component.exports